if (!window.__swCardSwatches) {
  window.__swCardSwatches = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.sw-product-card__swatch');
    if (!button) return;
    const card = button.closest('.sw-product-card');
    if (!card) return;

    const image = card.querySelector('.sw-product-card__image:not(.sw-product-card__image--hover)');
    const hover = card.querySelector('.sw-product-card__image--hover');
    if (image && button.dataset.swSrc) {
      image.srcset = button.dataset.swSrcset || '';
      image.src = button.dataset.swSrc;
      if (button.dataset.swAlt) image.alt = button.dataset.swAlt;
    }
    if (hover) {
      if (button.dataset.swHoverSrc) {
        hover.removeAttribute('hidden');
        hover.srcset = button.dataset.swHoverSrcset || '';
        hover.src = button.dataset.swHoverSrc;
      } else {
        hover.setAttribute('hidden', '');
      }
    }

    card.querySelectorAll('.sw-product-card__swatch').forEach((swatch) => {
      swatch.setAttribute('aria-pressed', swatch === button ? 'true' : 'false');
    });

    if (button.dataset.swUrl) {
      card.querySelectorAll('[data-sw-card-link]').forEach((link) => {
        link.href = button.dataset.swUrl;
      });
    }
  });
}
